'use client'

import { useAtomValue } from '@effect/atom-react'
import { Cause, Effect, Layer } from 'effect'
import * as AsyncResult from 'effect/unstable/reactivity/AsyncResult'

import { PublicApiConfig } from '@viziertronic/config/public'

import { createAtomRuntime } from '#runtime/atom/atom.runtime.ts'

const atomRuntime = createAtomRuntime(Layer.empty)
const discordLoginUrlAtom = atomRuntime.atom(
  Effect.gen(function* () {
    const { apiEndpoint } = yield* PublicApiConfig
    const url = new URL(apiEndpoint + '/api/auth/login/discord')
    url.searchParams.set('application', 'app')
    // TODO: add path support
    // if (globalThis.location.pathname !== '/login') {
    //   url.searchParams.set('path', globalThis.location.pathname)
    // }
    return url.toString()
  }),
)

function DiscordSignIn() {
  const discordLoginUrl = useAtomValue(discordLoginUrlAtom)

  return AsyncResult.match(discordLoginUrl, {
    onSuccess: (result) => <a href={result.value}>Login with discord</a>,
    onFailure: (error) => <div>Error: {Cause.pretty(error.cause)}</div>,
    onInitial: () => <div>Loading...</div>,
  })
}

export default DiscordSignIn
